module.exports = __webpack_public_path__ + "img/ic_fluent_edit_20_regular.29a82b47.svg";